/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useRef } from 'react';
import { FlexLayoutStyled } from '../styles';
import DOMPurify from 'dompurify';
import { run as runActions } from '../../../../store/workspaces/workspaces/run';
import { useTranslation } from 'react-i18next';
import { ContextMenuComponent } from '@syncfusion/ej2-react-navigations';

const renderField = (field, args) => {
  const fieldValue = args[field.attribute.name];
  return field.type === 'richtext'
    ? <div key={field.id} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(fieldValue) }} />
    : <div key={field.id}>{fieldValue}</div>;
};

export const renderCardTemplate = (args, navData, actionsState) => {
  const menuRef = useRef(null);
  const containerRef = useRef(null);
  const { t } = useTranslation();

  const contextMenuItems = navData.widgetData.menu.context.elements.map(element => ({
    text: t(element.label),
    id: element.label,
  }));

  const handleMenuClick = (argsMenu) => {
    const selectedText = argsMenu.item.properties.id;
    const matchingElement = navData.widgetData.menu.context.elements.find(el => el.label === selectedText);
    const eventKey = matchingElement?.events.find(event => ['onClick', 'onLoad'].includes(event?.type))?.key;
    runActions(eventKey, navData.widgetData.dataID, { ...actionsState }, null);
  };

  return (
    <div
      id="target-kanban-card"
      ref={containerRef}
      style={{ position: 'relative', userSelect: 'none' }}
    >
      {/* <ContextMenuComponent
        ref={menuRef}
        target="#target-kanban-card"
        items={contextMenuItems}
        select={handleMenuClick}
      /> */}

      <FlexLayoutStyled css={navData.widgetData.style}>
        {navData.widgetData.sections.map(section => (
          <div key={section.key} className={`${section.class}`}>
            {section.fieldSets.map(fieldSet => (
              <div
                key={fieldSet.key}
                className={`${fieldSet.class}`}
                style={{ flex: `1 0 ${100 / section.fieldSets.length}%` }}
              >
                {fieldSet.fields.map(field => (
                  <div
                    key={field.key}
                    className={`m-1 ${field.class}${field.hidden ? ' hidden' : ''}`}
                  >
                    {renderField(field, args)}
                  </div>
                ))}
              </div>
            ))}
          </div>
        ))}
      </FlexLayoutStyled>
    </div>
  );
};
